<template>
  <div class="central_content">
    <Button
      @click="
        upData = {};
        title = '添加';
        reminder1 = true;
      "
      type="primary"
      >添加</Button
    >
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="state">
        <span v-if="row.state == 0">禁用</span>
        <span v-if="row.state == 1">正常 </span>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '编辑';
            reminder1 = true;
          "
          type="primary"
          >编辑</Button
        >
        <Button
          @click="
            upData = row;
            title = '删除';
            reminder1 = true;
          "
          type="primary"
          >删除</Button
        >
      </template>
    </Table>
    <Modal
      @on-ok="settleAccounts"
      width="500"
      v-model="reminder1"
      :title="title"
    >
      <div v-if="title == '删除'">删除</div>
      <div v-else>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>名称:</div>
          <div>
            <Input
              v-model="upData.name"
              placeholder="名称"
              style="width: 300px"
            />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态：</div>
          <div>
            <RadioGroup v-model="upData.state">
              <Radio :label="0">禁用</Radio>
              <Radio :label="1">正常</Radio>
            </RadioGroup>
          </div>
        </div>
      </div>
    </Modal>

    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      title: "",
      parameter: { pageNow: 1 },
      userList: { list: [] },
      remark: null,
      upData: {},
      reminder1: false,
      columns: [
        {
          title: "id",
          align: "center",
          key: "id",
        },
        {
          title: "名称",
          align: "center",
          key: "name",
        },

        {
          title: "状态",
          align: "center",
          slot: "state",
        },

        {
          title: "创建时间",
          align: "center",
          key: "createTime",
        },
        {
          title: "修改时间",
          align: "center",
          key: "modifyTime",
        },

        {
          title: "操作",
          align: "center",
          className: "fontcolor",
          slot: "config",
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  mounted: function () {
    this.getData();

    if (localStorage.getItem("role") == "管理员") {
      this.columns.pop();
    }
  },
  methods: {
    settleAccounts() {
      if (this.title == "添加") {
        api.ProductGroupAdd(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "编辑") {
        api.ProductGroupEdit(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.ProductGroupDel(this.upData.id).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.ProductGroupQueryList(this.parameter).then((res) => {
        this.userList = res.body.data;
      });
    },
  },
};
</script>

<style scoped>
</style>